export default "__VITE_ASSET__CkGtU2ej__"